export default function updateProductName() {
    $('body').on('product:afterAttributeSelect', (e, response) => {
        const newName = response.data.product.productName;
        const nameRow = $('.product-name');
        nameRow.text(newName);
    });
}
